import React, { useEffect, useState } from 'react';
import { ItemInput } from '../../../@types';
import { CloseIcon, RemoveIcon } from '../../../assets/icons';
import ExpandDown from '../../../assets/icons/ExpandDown';
import ExpandUp from '../../../assets/icons/ExpandUp';
import { useInventorySearch } from '../../../hooks';
import { formatMoney } from '../../../utils';
import { SearchInput } from '../SearchInput';

interface Props {
    item: ItemInput;
    index: number;
    removeItem: (index: number) => void;
    updateCell: (rowIndex: number, columnId: string, value: string | number) => void;
    updateRow: (rowIndex: number, updatedRow: ItemInput) => void
    errors: string[];
    updateError: (index: number, error: string[]) => void;
    isSearchInput: boolean;
    expanded:boolean;
    setExpanded: (index: number) => void;
  }
  
  const LineItemMobile: React.FC<Props> = ({ item, isSearchInput , index, removeItem, updateCell, updateRow, errors,  updateError, expanded,  setExpanded,  }) => {
    const handleUpdate = (field: keyof ItemInput, value: string | number) => {
      updateCell(index, field as string, value);
      if (errors && errors.includes(field as string)) {
        errors = errors.filter((err) => err !== field);
      }
    };
    const {
        data: inventories,
        isSearching: isInventorySearching,
        handleSearch: handleInventorySearch,
      } = useInventorySearch();
      const [showNewInventoryModal, setShowNewInventoryModal] = React.useState<boolean>(false);
      const handleInventorySearchDebounced = React.useCallback(handleInventorySearch, []);
      const [isRowExpanded, setIsRowExpanded] = useState(true);  
      const handleItemSelect = React.useCallback((itemData: ItemInput | null) => {
        if (itemData) {
          updateRow(index, { ...itemData, quantity: 1, rate: itemData.rate as number });
        } else {
          updateRow(index, { id: '', name: '', quantity: 0, rate: 0 });
        }
      }, [index, updateRow]);
      useEffect(() => {
        console.log(item)
      }, [item])
  

      const [expandedTableIndex, setExpandedTableIndex] = useState<number | null>(0); 


      const handleToggleExpansion = () => {
        setExpanded(index);
      };
      

      return (
        <div className="p-2 relative items-center" >
          <button
            type="button"
            className="ml-[20em] p-2 rounded mt-[-1em] " 
            onClick={() => handleToggleExpansion()}
          >
        
            {expandedTableIndex === index ? <ExpandUp /> : <ExpandDown />}
            <span className="ml-2">
              {isRowExpanded ? '' : ''}
            </span>
          </button>
          
          {expanded && (
           
          <div className="p-2 bg-white mt-[-4em] ml-[0.3em] items-center ">
          <label className="text-gray-700 text-[12px] mt-[2em] pt-[4em] pl-4 ml-[-0.5em]">Item Name</label>
          {isSearchInput ? (
            <SearchInput
              placeholder="Enter Item Name"
              data={inventories}
              displayKey="name"
              isLoading={isInventorySearching}
              classNames=" shadow-inner placeholder:text-[#B4B4B4] items-center ml-[0.4em]  placeholder:text-[13.25px] w-[310px]  border-none bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4]"
              value={item?.id}
              selected={item.id ? item : null}
              clearIcon={CloseIcon}
              clearIconClass="mr-[0.9em] "
              handleChangeText={handleInventorySearchDebounced}
              onSelect={handleItemSelect}
              dropdownClassName="w-[300px] ml-[0.9em] "
              dropdownStyle={{
                maxHeight: '800px',
                overflowY: 'auto',
              }}
              emptyMessage={'No Items yet'}
            />
          ) : (
            <input
              type="text"
              placeholder="Enter Item Name"
              className="border-none  bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4]  p-2 ml-[0.5em] placeholder:text-[13.25px] w-[310px]"
              value={item?.name}
              onChange={({ target }) => handleUpdate('name', target.value)}
            />
          )}
          {errors.includes('name') && (
            <p className="text-red-500 text-xs mt-1">Please enter a value</p>
          )}
      <div className="grid grid-cols-2 gap-6">
  <div className="flex flex-col ml-[1em]">
      <label className="text-gray-700 text-[12px] mt-[2em] ml-[-0.5em] ">Quantity</label>
      <input
        type="number"
        className={`border-none p-2 ml-[-0.4em]  w-[147px]  bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4]  ${errors.includes('quantity') ? 'border-red-500' : ''}`}
        placeholder="Quantity"
        value={item?.quantity}
        onChange={({ target }) => handleUpdate('quantity', target.value)}
      />
      {errors.includes('quantity') && (
        <p className="text-red-500 text-xs mt-1">Please enter a value</p>
      )}
 </div>
 <div className="flex flex-col">
      <label className="text-gray-700 text-[12px] mt-[2em]">Rate</label>
      <input
        type="number"
className={` p-2 w-[147px] border-none bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4] ${errors.includes('rate') ? 'border-red-500' : ''}`}
placeholder="Rate"
value={item?.rate}
onChange={({ target }) => handleUpdate('rate', target.value)}
/>
{errors.includes('rate') && (
<p className="text-red-500 text-xs mt-1">Please enter a value</p>
)}
  </div>
  </div>
   <div className="flex flex-col  ">
  <label className="text-gray-700 text-[12px] mt-[2em] ml-[0.5em]">Total Amount</label>
  <input
                type="text"
                readOnly
                placeholder="Amount"
                className='border-none bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4] ml-[0.4em] p-2 placeholder:text-[13.25px] w-[310px]'
                value={
                  !isNaN(Number(item?.quantity)) && !isNaN(Number(item?.rate))
                    ? (Number(item?.quantity) * Number(item?.rate)).toLocaleString()
                    : ''
                }
              />
              </div>
<button type="button" className="ml-[20em] text-white p-2 rounded mt-[2em]" onClick={() => removeItem(index)}>
<RemoveIcon/>
<span className="ml-2"></span>
</button>
</div>
          )}
    {!expanded && (
  <div className="grid grid-cols-2 bg-white  p-3 mt-[-3.5em] ml-[-0.3em]">
    <div className="">
      <input
        type="text"
        readOnly
        placeholder="Item Name"
        value={item?.name}
        className="border-none  p-2 placeholder:text-[13.25px] w-[75px]"
      />
    </div>
    <div className="text-right">
    <input
  type="text"
  readOnly
  placeholder="Amount"
  className="border-none p-2 placeholder:text-[13.25px] w-[75px]"
  value={
    !isNaN(Number(item?.quantity)) && !isNaN(Number(item?.rate))
      ? (Number(item?.quantity) * Number(item?.rate)).toFixed(2)
      : ''
  }
/>
    </div>
  </div>
)}

    </div>
);
};

export {LineItemMobile} ;